import { Component } from '@angular/core';
import { AndromedaCustomTooltipDirective } from '../andromeda-custom-tooltip/andromeda-custom-tooltip.directive';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-entity-cell-render',
  imports: [AndromedaCustomTooltipDirective],
  templateUrl: './entity-cell-render.component.html',
  styleUrl: './entity-cell-render.component.scss',
})
export class EntityCellRenderComponent implements ICellRendererAngularComp {
  params: any;
  entity = '';
  tooltipEntity = '';

  agInit(params: any): void {
    this.params = params;
    this.entity = this.params.value;
    this.tooltipEntity = this.params.data.responsibleEntityTooltip;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
